import * as z from "zod/v4";

export const getMarketingAgentStatisticalSignificance = {
  name: "getMarketingAgentStatisticalSignificance" as const,
  input: z.object({
    /** Max number of days to look back */
    days: z.number(),
  }),
  output: z
    .object({
      /** P-value from the statistical test (0 to 1) */
      pValue: z.number().min(0).max(1),
      /** Percentage improvement of variant over control; null if control is zero */
      percentageImprovement: z.number().nullable(),
      /** Traffic percentage allocated to variant (0-100); control is 100 minus this */
      variantTrafficPercentage: z.number().min(0).max(100),
      /** How marketing agent compares to legacy automations */
      improvementDirection: z.enum(["better", "worse", "comparable"]),
    })
    .nullable(),
};
